var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"srm-upload"},[_c('a-upload',{attrs:{"fileList":_vm.fileList,"remove":_vm.handleRemove,"beforeUpload":_vm.beforeUpload,"multiple":_vm.multiple}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edef488a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srm-detailMes/srm-upload.vue
// module id = null
// module chunks = 